import { render } from "./AntBlock.vue?vue&type=template&id=48507080&scoped=true"
import script from "./AntBlock.vue?vue&type=script&lang=js"
export * from "./AntBlock.vue?vue&type=script&lang=js"

import "./AntBlock.vue?vue&type=style&index=0&id=48507080&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48507080"]])

export default __exports__